import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiFlexItem, EuiSpacer} from '@elastic/eui';
import FormularioContainer from './Formulario/container';
import { ActionType, CREATE, UPDATE, ADJUNTAR, UPLOAD,REMOVE, USER_PERMISSIONS, CREATE_FINSEMANA, UPDATE_FINSEMANA } from './constants';
import { Action } from '../../components/Menus/interface';
import { Menu } from '../../components/Menus';
import FiltrosMenu from '../../components/Menus/filtros';
import ModalYesNo from '../../components/Modal/YesNo';
import { useUserSettings } from '../../context/CurrentUserContext';
import { SelectorUsuarioParte } from './Delegados/component';
import { HorasUserContainer as HorasUser} from '../../components/HorasUsuariosView/container';
import { MaskLoad } from '../../components/Layout';
import { PanelInfoBloqueoApp } from '../../components/Layout/PanelInformativoBloqueo';
import { useNotifications } from '../../../../shared/hooks/Notifications';
interface Props {
  data: any;
  handleCreate(parte: any, isWeekEnd:boolean, adjuntos?: any): any;
  handleRemove(idParte: number): any;
  handleUpdate(parte: any, isWeekEnd:boolean): any;
  handleFilter(filtro: any): any;
  handleAdjuntar(selected: any): any;
  getColumns(dni?:string): any;
  isLoading:boolean;
  //currentUser:any;
  currentSettingsApp:any;
}

const PartesScreen = (props: Props) => {
  
  const ref:any = useRef();
  const {currentUser}:any = useUserSettings();
  const {launchNotification} = useNotifications();
  
  let { data, handleCreate, handleRemove, handleUpdate, handleFilter, handleAdjuntar, getColumns, isLoading ,currentSettingsApp } = props;

  let [isModalVisible, setIsModalVisible] = useState(false);
  let [openRemoveModal, setOpenRemoveModal] = useState<any>({open:false,dataRequest:[]});
  let [selected, setSelected] = useState<any>([]);
  let [actionType, setActionType] = useState<ActionType>(CREATE);
  let [filtro, setFiltro] = useState<any>(undefined)
  let [user,setUser] = useState(currentUser);
  let [columnsUser,setColumnsUser]= useState<any>(undefined);

  const haveCurrentUser = useMemo(()=>(currentUser!==undefined && currentUser!==null && Object.keys(currentUser).length>0),[currentUser])
  const haveUser = useMemo(()=>(user!==undefined && user!==null && Object.keys(user).length>0),[user])

  useEffect(()=>{if(!haveUser && haveCurrentUser){setUser(currentUser)}},[currentUser])

  const permisosUser = useMemo(()=>{
    if(haveUser)
    {
      switch (currentUser.perfil) {
        case 'USR':
          return USER_PERMISSIONS.USR
        case 'RRH':
          return USER_PERMISSIONS.RRH
        case 'RAR':
          return USER_PERMISSIONS.RAR
        case 'FIS':
          return USER_PERMISSIONS.FIS
        case 'FAC':
          return USER_PERMISSIONS.FAC
        case 'ADM':
          return USER_PERMISSIONS.ADM
      }
    }
  },[currentUser])

  const bloqueoActions = useMemo(()=>{return (currentSettingsApp!==undefined && currentSettingsApp.bloqueado === true) ? true : false},[currentSettingsApp])
  const hayValidados = useMemo(()=> selected.length>0 && selected.filter((p:any)=> p.estado>1).length>0,[selected]);

  const columnsConfig = async () =>{
    columnsUser = await getColumns(user.dni);
    if(columnsUser)
      setColumnsUser(columnsUser.columnas)
  }

  useEffect(()=>{
		columnsConfig();
	},[])

  useEffect(() => { closeModal(false); if(openRemoveModal){setOpenRemoveModal({open:false,undefined})}}, [data]);
  useEffect(()=> {columnsConfig()},[user])
  useEffect(()=> {if(filtro){filtrarPartes()}},[filtro,user])
  useEffect(() => {if(!isLoading){setOpenRemoveModal({open:false,dataRequest:[]})}},[isLoading])

  const isWeekEndSelected = useMemo(()=>(selected.length===1 && selected[0].esFinSemana),[selected])

  const prepareEdit = useCallback(() => {
    const action:ActionType = isWeekEndSelected ? UPDATE_FINSEMANA : UPDATE;
    setActionType(action);
    showModal();
  },[isWeekEndSelected])

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareCreateFinSemana = useCallback(() => {
    setActionType(CREATE_FINSEMANA);
    showModal();
  },[])

  const prepareAdjuntar = useCallback(() => {
    // if(hayValidados)
    // {launchNotification({type:"warning",title:"Adjuntar",message:"No se pueden adjuntar archivos a partes validados."})}
    // else{
    setActionType(ADJUNTAR);
    showModal();
    //}
  },[hayValidados])

  const prepareUpload = useCallback(() => {
    setActionType(UPLOAD);
    showModal();
  },[])

  const onCreate = (newData: any, adjuntos: any, isWeekEnd: boolean) => {
    if (newData && handleCreate) {
      if(haveCurrentUser && currentUser.esDelegado && currentUser.dni !== user.dni)
        setOpenRemoveModal({open:true, dataRequest:[newData,adjuntos]});
      else
        handleCreate(newData,isWeekEnd,adjuntos);
    }
  }

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      if(selected.length > 0){
        setActionType(REMOVE);
        setOpenRemoveModal({open:true, dataRequest:[...[selected]]})
      }else{
        handleRemove(selected);
      }
    }
  },[selected, handleRemove])

  const onUpdate = (newData: any, refreshAdjuntos: boolean, isWeekEnd:boolean) => {
    if (newData && handleUpdate) {
      if(!refreshAdjuntos)
      {
        if(haveCurrentUser && currentUser.esDelegado && currentUser.dni !== user.dni)
        setOpenRemoveModal({open:true, dataRequest:[...[newData]]})
        else
        handleUpdate(newData,isWeekEnd)
      }
      else
        filtrarPartes()
    }
  }

  const onAdjuntar = () => {
    if (selected && handleAdjuntar) {
      handleAdjuntar(selected);
    }
  }

  const filtroInicial = (filtro:any)=>{
    onChangeFilter(filtro);
  }

  const onChangeFilter = (newFilter:any)=>{
    setFiltro(newFilter);
  }

  const filtrarPartes = () => {
    handleFilter && handleFilter(({...filtro,...{dni:user.dni}}))
  }

  const onExport = () =>{
    ref.current && ref.current.onExport()
  }

  const onUpload = () =>{
    filtrarPartes()
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onSelected = (selection: any) => {
    setSelected([...selection])
  }

  const getSelected = () =>{
    switch (actionType.tipo) {
      case 'I':
      case 'IFS':return undefined;
      case 'U':
      case 'UFS':return selected[0];
      case 'A':return selected;
    }
  }

  const closeModal = (refresh:any) => { if(refresh && (actionType.tipo==="U" || actionType.tipo==="UFS")){ filtrarPartes(); } setIsModalVisible(false)};
  const showModal = () => setIsModalVisible(true);

  const onConfirmModal = (response:any) => {
    if(response!==undefined && response === true){
      const request1=openRemoveModal.dataRequest[0];
      const request2=openRemoveModal.dataRequest[1];
      
      switch (actionType.tipo) {
        case 'I':  return handleCreate(request1, false, request2);
        case 'IFS': return handleCreate(request1,true, request2);
        case 'U': return handleUpdate(request1,false);
        case 'UFS': return handleUpdate(request1,true);
        case 'R': return handleRemove(request1);
      }
    }else{
      setOpenRemoveModal({open:false,dataRequest:[]})
    }
  }

  const getHandle = () =>{
    switch (actionType.tipo) {
      case 'I':
      case 'IFS':return onCreate;
      case 'U':
      case 'UFS':return onUpdate;
      case 'A':return onAdjuntar;
      case 'UF':return onUpload;
      default : return ()=>{};
    }
  }

  const onChangeUser = (userSel:any) =>{
    const {horasLunesJueves,horasLunesJuevesContinuo,horasViernes,horasViernesContinuo} = currentUser;

    setUser({...userSel,horasLunesJueves,horasLunesJuevesContinuo,horasViernes,horasViernesContinuo})
  }

  const isDisabledAdjuntar = useCallback(() => {
    // const adj = (permisosUser && filtro) && (permisosUser.adjuntar.includes(filtro.estado) || currentUser.esDelegado);
    // return (selected.length>0 && adj ? false : true)
    return (selected.length>0 ? false : true)
  },[selected,filtro,permisosUser])

  const isDisabledCrear = useCallback(() => {
    return bloqueoActions
  },[bloqueoActions])

  const isDisabledEditar = useCallback(() => {
    const edit = (permisosUser && filtro) && (!bloqueoActions && (permisosUser.editar.includes(filtro.estado) || currentUser.esDelegado));
    const selectedPermissions = (selected.length === 1)
    // const selectedPermissions = (selected.length === 1 && selected[0].facturado===false && selected[0].estado===1)
     return (selectedPermissions && edit ? false : true)
  },[selected,filtro,permisosUser,bloqueoActions])

  const isDisabledEliminar = useCallback(() => {
    const edit = (permisosUser && filtro) && (!bloqueoActions && (permisosUser.eliminar.includes(filtro.estado) || (haveCurrentUser && currentUser.esDelegado)));
    return (selected.length > 0 && edit ? false : true)
  },[selected,filtro,permisosUser,bloqueoActions,haveCurrentUser,currentUser])

  const getFiltroHoras = useMemo(() =>{
    if(filtro!==undefined && haveUser){
      const {fechaDesde,fechaHasta}=filtro
      const {dni}=user
      return {dni,fechaDesde,fechaHasta}
    }
  },[filtro,haveUser,user])

  const Actions = useMemo(():Action[] => [
    {component:<HorasUser filtro={getFiltroHoras} user={user&&user.nombre} dateInit/>},
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {actionGroup:{actions:[
      {text:"Datos",size:"s", isDisabled: false},
      {handle:prepareUpload,text:"Importar",size:"s", isDisabled:isDisabledCrear()},
      {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
    ]}},
    {handle:prepareAdjuntar,text:`Adjuntar (${selected.length})`,size:"s", isDisabled:isDisabledAdjuntar(), className: (isDisabledAdjuntar() ? "btnDisabled" : "btnAdjuntar")},
    {handle:onRemove,text:`Eliminar (${selected.length})`,color:"danger",size:"s", isDisabled:isDisabledEliminar()},
    {handle:prepareEdit,text:"Editar",color:"secondary",size:"s",isDisabled:isDisabledEditar()},
    {actionGroup:{actions:[
      {text:"Nuevo",size:"s", color:'primary', isDisabled:isDisabledCrear()},
      {handle:prepareCreate,text:"Normal",color:"primary",size:"s", isDisabled:isDisabledCrear()},
      {handle:prepareCreateFinSemana,text:"Fin de semana desplazado",color:"primary",size:"s", isDisabled:isDisabledCrear()}
    ]}}
  ],[selected,user,prepareUpload,prepareAdjuntar,onRemove,prepareEdit,prepareCreate,onFilterClear])

  const Mask = useMemo(()=>{return (<MaskLoad isLoading={isLoading}/>)},[isLoading])

  let modal = (
    <>
    {Mask}
    <FormularioContainer tipo={actionType.tipo} title={actionType.title} esDelegado={(haveCurrentUser&&currentUser.esDelegado)}
      handle={getHandle()} selected={getSelected()} onClose={closeModal} 
      user={haveUser&&user} userConnect={currentUser}/>
    </>
    );

    let modalConfirm = (
      <>
        {Mask}
        <ModalYesNo onClose={onConfirmModal} isOpen={openRemoveModal.open} answer={haveCurrentUser&&currentUser.dni!==user.dni ? actionType.answer : undefined}/>
      </>
      );

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          selected={selected}
          onSelected={onSelected}
          onChange={()=>{}}
          ref={ref}
          columnsUser={columnsUser}
          user={user}
        />
        {isModalVisible ? modal : null}
        {openRemoveModal.open ? modalConfirm : null}
      </>
    )
  }

  return (
    <>
      <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap>
        <EuiFlexItem>
          <EuiFlexGroup gutterSize="s" alignItems="center" justifyContent="flexStart" >
            <FiltrosMenu selectorEstado filtroInicial={filtroInicial} dateInit onChangeFilter={onChangeFilter} onFilterData={filtrarPartes}/>
          </EuiFlexGroup>
          </EuiFlexItem>
          {haveCurrentUser && currentUser.esDelegado?
            <EuiFlexItem grow={false}>
              <SelectorUsuarioParte title='Usuarios' user={user} onChangeUser={onChangeUser} currentUser={currentUser}/>
            </EuiFlexItem>
            :null}
          <EuiFlexItem>
          {<Menu actions={Actions} className="actions"/>}
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      {getView()}
    </>
  );
};

export default PartesScreen;
